import React, { useCallback, useMemo } from 'react'
import { Checkbox } from 'antd'
import { filter, find, includes, isEmpty, isNil, map } from 'lodash'
import PropTypes from 'prop-types'

const PriorityTaskAllocationCheckAll = ({
  menuCurationTasks,
  priorityTaskId,
  selectedAllocationIds,
  onSelectionChange,
}) => {
  const availableAllocationIds = useMemo(
    () =>
      map(
        filter(menuCurationTasks, task => {
          const currentAllocation = find(
            task.priorityTaskAllocations,
            allocation => allocation.priorityTask?.id === priorityTaskId,
          )
          return !isNil(currentAllocation)
        }),
        task => {
          const currentAllocation = find(
            task.priorityTaskAllocations,
            allocation => allocation.priorityTask?.id === priorityTaskId,
          )
          return currentAllocation.id
        },
      ),
    [menuCurationTasks, priorityTaskId],
  )

  const isAllSelected = useMemo(
    () =>
      !isEmpty(availableAllocationIds) &&
      availableAllocationIds.every(id => includes(selectedAllocationIds, id)),
    [availableAllocationIds, selectedAllocationIds],
  )

  const handleCheckAllChange = useCallback(
    e => {
      if (e.target.checked) {
        onSelectionChange(availableAllocationIds)
      } else {
        onSelectionChange([])
      }
    },
    [availableAllocationIds, onSelectionChange],
  )

  if (isEmpty(availableAllocationIds)) {
    return null
  }

  return (
    <Checkbox
      checked={isAllSelected}
      onChange={handleCheckAllChange}
      style={{ marginRight: 8 }}
    />
  )
}

PriorityTaskAllocationCheckAll.propTypes = {
  menuCurationTasks: PropTypes.array.isRequired,
  priorityTaskId: PropTypes.string.isRequired,
  selectedAllocationIds: PropTypes.array.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
}

export default PriorityTaskAllocationCheckAll
